<template>
  <div :class="classes">
    <wt-paged-table :isAddPageToRouter="true" :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="true" ref="table" @size-change="handleSizeChange" :layout="layout" :pageSizes="pageSizes">
      <base-table
        ref="multipleTable"
        :columns="tableLabels"
        :selectType="selectType"
        :table-data="tableData"
        :selected-keys="selectedKeys"
        @selection-change="handleSelectionChange"
      >
      <template slot="status" slot-scope="scope">
        {{scope.row.status_text}}
        <el-tag v-if="scope.row.urgent" type="danger" size="small">加急</el-tag>
        <el-tag v-if="scope.row.overDue" type="warning" size="small">逾期</el-tag>
      </template>
      <template slot="operate" slot-scope="scope">
        <slot :row="scope.row"></slot>
      </template>
      
      </base-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-production-task-table'

export default {
  name: 'pt-production-task-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    selectType:{
      type: String,
      default: 'checkbox'
    },
    selectedKeys:{
      type:[String,Array],
      default:''
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next,jumper'
    },
    pageSizes: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  methods: {
    resetPage(){
      this.$refs.table.resetPage()
    },
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    reload () {
      this.$refs.table.load()
      this.clearSelection()
    },
    clearSelection () {
      this.$refs.multipleTable.clearSelection()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    handleSelectionChange(val){
      this.$emit('selection-change',val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
